import { useQuery } from '@tanstack/react-query';
import { Link } from '@tanstack/react-router';
import { ChevronLeft } from 'lucide-react';
import { Card } from '@/components/Card';
import { artigo } from '@/portal/portal.api';
import { dataCurta } from '@/portal/formato';

/** Detalhe de um artigo da base de conhecimento, versão cliente. */
export function ArtigoPage({ id }: { id: string }) {
  const consulta = useQuery({
    queryKey: ['portal', 'artigo', id],
    queryFn: () => artigo(id),
  });

  if (consulta.isPending) {
    return <p className="text-sm text-muted-foreground">Carregando…</p>;
  }
  if (consulta.isError || !consulta.data) {
    return <p className="text-sm text-muted-foreground">Artigo não encontrado.</p>;
  }

  const dados = consulta.data;

  return (
    <div className="space-y-4">
      <Link
        to="/base"
        className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
      >
        <ChevronLeft className="h-4 w-4" aria-hidden />
        Voltar para Soluções
      </Link>

      <header>
        <p className="font-mono text-xs text-muted-foreground">{dados.codigo}</p>
        <h1 className="text-xl font-semibold">{dados.titulo}</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Atualizado em {dataCurta(dados.atualizadoEm)}
        </p>
      </header>

      <Card className="px-5 py-6">
        {/* O HTML já foi higienizado no servidor durante a gravação do artigo. */}
        <div
          className="prose prose-sm max-w-none"
          dangerouslySetInnerHTML={{ __html: dados.corpoHtml }}
        />
      </Card>
    </div>
  );
}
